import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listCustomerGiftCard, registerCustomerGiftCard } from './api';
import {
  LIST_CUSTOMER_GIFT_CARD_REQUEST,
  LIST_CUSTOMER_GIFT_CARD_SUCCESS,
  CUSTOMER_GIFT_CARD_LIST_REQUESTING,
  CUSTOMER_GIFT_CARD_OBJECT_REQUESTING,
  REGISTER_CUSTOMER_GIFT_CARD_REQUEST,
  RESET_CUSTOMER_GIFT_CARD_ISFETCHING,
  GET_CUSTOMER_GIFT_CARD_SUCCESS
} from './constants';

function* list() {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_GIFT_CARD_LIST_REQUESTING });
    const response = yield call(listCustomerGiftCard);
    yield put({
      type: LIST_CUSTOMER_GIFT_CARD_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_GIFT_CARD_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* register(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_GIFT_CARD_OBJECT_REQUESTING });
    const response = yield call(registerCustomerGiftCard, action.data);
    yield put({
      type: GET_CUSTOMER_GIFT_CARD_SUCCESS,
      payload: response.data
    });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_GIFT_CARD_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* watchList() {
  yield takeLatest(LIST_CUSTOMER_GIFT_CARD_REQUEST, list);
  yield takeLatest(REGISTER_CUSTOMER_GIFT_CARD_REQUEST, register);
}

export default function* customerGiftCardSagas() {
  yield all([watchList()]);
}
